import {atom} from "jotai";

/**
 * Total quantity of items in the logged-in parent's Shopify cart.
 * Hydrated from the Discovery header (outside `"use cache"`), then updated
 * by add/remove cart actions so the header badge stays in sync without a
 * layout RSC refresh.
 */
export const cartItemCountAtom = atom(0);
